import React from "react"
import { BoxProps } from "@/components/Box"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import { LayoutProps } from "styled-system"

export type CardStyle = {
  imageSrc: string
} & LayoutProps

export type MerchantCardProps = {
  text: string
  textColor?: string
  direction?: "left" | "right"
  cardStyle: CardStyle
  isFixedWidth?: boolean
} & BoxProps

const MerchantCard = ({
  text,
  textColor = "#F7F9FA",
  direction = "left",
  cardStyle,
  isFixedWidth = false,
  ...restProps
}: MerchantCardProps) => {
  const regularStyle = {
    backgroundImage: [`url(${cardStyle.imageSrc})`],
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  }
  const fixedWidthStyle = {
    ...regularStyle,
    ...{
      flexShrink: 0,
      flexGrow: 0,
      flexBasis: cardStyle.width,
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  }

  return (
    <Flex
      padding={3}
      borderRadius={16}
      alignItems={"flex-end"}
      justifyContent={direction === "left" ? "flex-start" : "flex-end"}
      customCss={isFixedWidth ? fixedWidthStyle : regularStyle}
      width={cardStyle.width}
      height={cardStyle.height}
      {...restProps}
    >
      <Typography
        variant="p"
        color={textColor}
        fontWeight={600}
        lineHeight={"110%"}
        fontSize={15}
      >
        {text}
      </Typography>
    </Flex>
  )
}

export default MerchantCard
